import * as React from 'react';
import { FragmentId, Link } from '../scrollspy/scrollspy';
import { ITabsState } from '../../types/tabs';

import * as styles from './menu.css';

interface IMenuItemLinkProps {
  to: FragmentId;
  text: string;
  tabs?: Partial<ITabsState>;
}

export function MenuItemLink(props: IMenuItemLinkProps) {
  const { to, text, tabs } = props;

  return (
    <li>
      <Link className={styles['link']} activeClass={styles['link-active']} to={to} tabs={tabs}>
        {text}
      </Link>
    </li>
  );
}
